module.exports = __webpack_public_path__ + "static/media/pattern-bg-gestionale.96b2c31c.jpg";